import { createSlice } from '@reduxjs/toolkit';
import { performGlobalLogout } from './authSlice';

const initialState = {
	status: 'disconnected',
	lastMessage: null,
	gameEvents: [],
	gameEventSequence: 0,
	lastError: null,
	endpoint: null,
};

const socketSlice = createSlice({
	name: 'socket',
	initialState,
	reducers: {
		connect(state, action) {
			state.endpoint = action.payload;
			state.status = 'connecting';
			// drop any message left over from a previous session/game
			state.lastMessage = null;
			state.gameEvents = [];
		},
		disconnect(state) {
			state.status = 'disconnected';
		},
		connected(state) {
			state.status = 'connected';
			state.lastError = null;
		},
		disconnected(state) {
			state.status = 'disconnected';
		},
		messageReceived(state, action) {
			state.lastMessage = action.payload;
			const messageType = action.payload?.type || action.payload?.event;
			if (messageType === 'ROUND_STATE' || messageType === 'CARD_DEALT') {
				state.gameEventSequence += 1;
				state.gameEvents.push({
					sequence: state.gameEventSequence,
					message: action.payload,
				});
				if (state.gameEvents.length > 200) {
					state.gameEvents.shift();
				}
			}
		},
		errorOccurred(state, action) {
			state.lastError = action.payload;
			state.status = 'error';
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(performGlobalLogout.fulfilled, (state) => {
				state.status = 'disconnected';
				state.lastMessage = null;
				state.gameEvents = [];
				state.lastError = null;
				state.endpoint = null;
			});
	},
});

export const { connect, disconnect, connected, disconnected, messageReceived, errorOccurred } = socketSlice.actions;
export default socketSlice.reducer;